<template>
    <div class="base-radio">
        <b-form-radio-group
            v-model="selected"
            :name="name"
            :options="options"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
        ></b-form-radio-group>
        <!-- <div class="mt-3">Selected: <strong>{{ selected }}</strong></div> -->
    </div>
</template>

<script>
import {BFormRadioGroup} from "bootstrap-vue";
export default {
    name: "BaseRadioButtons",
    components: {BFormRadioGroup},
    data() {
        return {
            selected: this.selectedOption
        }
    },
    props: {
        name: {
            type: String,
            required: true
        },
        selectedOption: {
            type: String,
        },
        options: {
            type: Array,
            default: []
        },
         getValue: {
            type: Function,
            default: () => {
                console.log("Function getValue was not set!")
            }
        }
    },
    watch: {
        selectedOption(newVal, oldVal) {
            this.selected = newVal;
        },
        selected(newVal, oldVal) {
            this.getValue(this.name, newVal);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/BaseRadioButtons.vue